import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import CommonUiIcon from 'webapp/components/common/ui-icon';
import OnboardingGuidedTourSteps from 'webapp/components/onboarding/guided-tour/steps';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import type { Args } from 'webapp/components/popup/inner/modal';
import SubmitButton from 'webapp/components/submit-button';

export default class OnboardingGuidedTourPopupStartComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		if (!this.flowTourOnboardingService.hasSeenGuidedOnboardingPopupStart) {
			this.flowTourOnboardingService.markGuidedOnboardingPopupStartSeen();
		}
	}

	@action
	triggerAction() {
		this.analyticsService.event(TrackingEvent.GUIDED_ONBOARDING_TOUR_START, { origin: 'home' });
		this.flowTourOnboardingService.startTour();
	}

	<template>
		<div class="title title--vertical">
			<CommonUiIcon @name="DataboxLogo" @size="lg" />
			<span class="text">Ready to unlock the full potential of your data journey?</span>
		</div>

		<div class="content">
			<p>
				Opt in for our onboarding tour and discover how to select and monitor metrics that
				matter, effortlessly build your dashboard via wizard flow, and find and connect
				additional tools for centralizing your data.
			</p>

			<OnboardingGuidedTourSteps />

			<div class="controls2 controls2--center">
				<SubmitButton
					@text="Start onboarding tour"
					@size="big"
					@onTrigger={{this.triggerAction}}
				/>
				<SubmitButton
					@text="I’d rather explore on my own"
					@theme="grey-empty"
					@onTrigger={{this.close}}
				/>
			</div>
		</div>
	</template>
}
